/**
 * H5 现场 3 类角色与派单上下文（应用私有，不污染共享包）
 * 对应优化系统设计方案 §3.1，区别于 admin 后台 UserRole。
 *
 * 3 个角色：
 *   - 产地组：扫码绑定 IoT（E02）
 *   - 装柜组：装柜铅封（E04）+ 节点质检（E03/E05）
 *   - 迪拜团队：目的港签收与开箱（E06）
 */

/** 现场实操 3 类角色 */
export enum MobileRole {
  /** 产地组 */
  ORIGIN = 'ORIGIN',
  /** 装柜组 */
  LOADING = 'LOADING',
  /** 迪拜团队 */
  DUBAI = 'DUBAI',
}

/** 角色中文标签 */
export const MOBILE_ROLE_LABELS: Record<MobileRole, string> = {
  [MobileRole.ORIGIN]: '产地组',
  [MobileRole.LOADING]: '装柜组',
  [MobileRole.DUBAI]: '迪拜团队',
};

/** 角色 → 可见待办任务类型（用于按角色过滤，复用 bp-shared TaskType 值） */
export const ROLE_TASK_TYPES: Record<MobileRole, string[]> = {
  [MobileRole.ORIGIN]: ['SCAN_BIND_IOT'],
  [MobileRole.LOADING]: ['LOADING_SEAL', 'NODE_INSPECTION'],
  [MobileRole.DUBAI]: ['SIGN_UNBOX'],
};

/** Mock 登录账号 */
export interface MockAccount {
  username: string;
  password: string;
  role: MobileRole;
  name: string;
  location: string;
  title: string;
  initial: string;
}

export const MOCK_ACCOUNTS: MockAccount[] = [
  {
    username: 'changdi',
    password: '123456',
    role: MobileRole.ORIGIN,
    name: '李产地',
    location: '山东金乡',
    title: '产地组组长',
    initial: '李',
  },
  {
    username: 'zhuanggui',
    password: '123456',
    role: MobileRole.LOADING,
    name: '张装柜',
    location: '山东金乡',
    title: '装柜组组长',
    initial: '张',
  },
  {
    username: 'dibai',
    password: '123456',
    role: MobileRole.DUBAI,
    name: '赵迪拜',
    location: '迪拜港',
    title: '迪拜团队负责人',
    initial: '赵',
  },
];

/** 派单跳转上下文（经角色处理后携带，P1-6） */
export interface DispatchContext {
  taskNo: string;
  containerNo: string;
  nodeName: string;
  /** bp-shared TaskType 值 */
  taskType: string;
}
